module.exports = __webpack_public_path__ + "static/media/platoform.5e618f72.jpg";